import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import { useAuth } from 'context/auth';
import $createDataSource from 'utils/create-data-souce-instance';

import { CreateEditModal } from './components';

type Props = {
  materialId: number;
};

const MaterialPrice: FC<Props> = ({ materialId }) => {
  const { getClaims }: any = useAuth();

  const canLookPrice = getClaims(['CanLookPrice']);

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const requestDateSource = useMemo(() => {
    const defaultFilter = ['nomenclatureId', '=', materialId];
    return $createDataSource('/v1/MaterialPrice', 'id', { defaultFilter });
  }, [materialId]);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => {
    refGrid.current?.instance.refresh();
  };
  return (
    <div className="container-dev">
      <AppLayoutTop title="">
        <Button
          width={120}
          text="Создать"
          type="default"
          onClick={() => {
            setDetailId(null);
            setModalIsVisible(true);
          }}
        />
      </AppLayoutTop>

      {modalIsVisible && (
        <CreateEditModal
          changeVisible={setModalIsVisible}
          id={detailId}
          refresh={refresh}
          visible={modalIsVisible}
          materialId={materialId}
        />
      )}

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
        >
          <FilterRow visible={true} />

          <Column dataField="dateBegin" caption="Дата начала" dataType="date" />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" />
          <Column dataField="price" caption="Цена" visible={canLookPrice} />

          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <Button
                  icon="edit"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setDetailId(data.data.id);
                    setModalIsVisible(true);
                  }}
                />
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default MaterialPrice;
